import React from 'react';
import G from "../libs/Glob.mjs";
import appLib from "../libs/appLib.mjs";
import TextLabel from "../controls/TextLabel.mjs";
import {Button, ButtonGroup} from "reactstrap";
import CloseIcon from "../media/images/CloseIcon.mjs";
import libHelper from "../libs/libHelper.mjs";
import ListLibraryRoot from "./parts/ListLibraryRoot.mjs";
import ReloadIcon from "../media/images/ReloadIcon.mjs";
import CheckIcon from "../media/images/CheckIcon.mjs";

const prefix = "EditLibrary";

const EditLibrary = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			changes: 0,
			libID: props.libID || props.uuid || G.getPageParam('id')
		}
		this.uid = G.generateUid(prefix);
		this.setData = this.setData.bind(this);
		this.setButtons = this.setButtons.bind(this);
	}
	componentDidMount() {
		G.setStatus('pageTitle', G.label('Edit library'));
		this.setData();
	}
	async setData( data, callback ) {
		if ( ! this.state.libID ) return;
		const ns = { changes: this.state.changes +1 };
		if ( typeof data === 'undefined') {
			try {
				data = await appLib.getLibrary( this.state.libID );
			} catch ( e ) {
				console.error(e);
				return;
			}
			ns.changes = 0;
		} else {
			data.lastUpdate = Date.now();
		}
		ns.data = data;
		ns.helper = new libHelper(data, G.getLanguage() );
		this.setState(ns, async ()=>{
			this.setButtons();
			G.setStatus('knownTags', await appLib.tags() );
			if ( typeof callback === 'function') callback();
		});
	}
	setButtons() {
		if ( ! this.state.helper ) {
			G.setStatus('pageButtons');
			return;
		}
		G.setStatus('pageButtons', (
			<ButtonGroup
				style={{backgroundColor:"#fff",overflow:"hidden",borderRadius:".28rem"}}
				className={"btn-icon"}
			>
				{ this.state.changes === 0 ? (
					<Button
						color={"warning"}
						onClick={ ()=>{ G.gotoHomePage() }}
					>
						<i>
							<CloseIcon />
						</i>
						<b>
							<TextLabel value={"Close"} />
						</b>
					</Button>
				) : (
					<Button
						disabled={ this.state.changes === 0 }
						onClick={ ()=> this.setData() }
					>
						<i>
							<ReloadIcon />
						</i>
						<b>
							<TextLabel value={"Cancel"} />
						</b>
					</Button>
				) }
				<Button
					disabled={this.state.changes === 0}
					color="success"
					onClick={ async () => {
						await appLib.saveLibrary( this.state.data );
						this.setData();
					}}
				>
					<b>
						<TextLabel value={"Save"}/>
					</b>
					<i>
						<CheckIcon/>
					</i>
				</Button>
			</ButtonGroup>
		));
	}

	render() {
		if ( ! this.state.helper ) return "";
		return(
			<div className={'app-panel-full '+prefix} id={this.uid}>
				<h1>
					{ this.state.helper.getName() }
					<small>
						(<TextLabel value={ this.state.helper.getField('published') ? "Published" : "Unpublished" } />)
					</small>
				</h1>
				<div className={"panel-content"}>
					<ListLibraryRoot
						fh={ this.state.helper.root() }
						onChange={ this.setData }
					/>
				</div>
			</div>
		)
	}
}

export default EditLibrary;
